module.exports = __webpack_public_path__ + "img/home-silder3.6768b670.png";